import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import MainPage from "./MainPage"
import DetailPage from "./DetailPage"
import NewAreaPage from "./NewAreaPage"
import ContactErrorPage from "./ContactErrorPage"
// import TestComponent from "./components/TestComponent"

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/index" replace />} />
        <Route path="/index" element={<MainPage />} />
        <Route path="/detail/:id" element={<DetailPage />} />
        <Route path="/newarea" element={<NewAreaPage />} />
        <Route path="/contacterror" element={<ContactErrorPage />} />
        {/* <Route path="/testc" element={<TestComponent />} /> */}
      </Routes>
    </Router>
  );
}